interface SignalNoisePoint {
  date: string;
  signal: number;
  noise: number;
}

interface SignalNoiseChartProps {
  data: SignalNoisePoint[];
  height?: number;
}

export function SignalNoiseChart({ data, height = 180 }: SignalNoiseChartProps) {
  if (data.length === 0) {
    return (
      <div style={{ height, display: "flex", alignItems: "center", justifyContent: "center", color: "var(--bios-text-muted)", fontSize: 13 }}>
        No data yet.
      </div>
    );
  }
  const max = Math.max(...data.flatMap((d) => [d.signal, d.noise]), 1);
  const width = 600;
  const padding = 24;
  const innerW = width - padding * 2;
  const innerH = height - padding * 2;
  const stepX = data.length > 1 ? innerW / (data.length - 1) : 0;

  const toPath = (key: "signal" | "noise") =>
    data
      .map((d, i) => {
        const x = padding + i * stepX;
        const y = padding + innerH - (d[key] / max) * innerH;
        return `${i === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)}`;
      })
      .join(" ");

  return (
    <div style={{ width: "100%" }}>
      <svg viewBox={`0 0 ${width} ${height}`} width="100%" height={height} preserveAspectRatio="none">
        <defs>
          <linearGradient id="bios-signal-grad" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="var(--bios-signal)" stopOpacity="0.4" />
            <stop offset="100%" stopColor="var(--bios-signal)" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path
          d={`${toPath("signal")} L${(padding + (data.length - 1) * stepX).toFixed(1)},${(padding + innerH).toFixed(1)} L${padding},${(padding + innerH).toFixed(1)} Z`}
          fill="url(#bios-signal-grad)"
        />
        <path d={toPath("signal")} stroke="var(--bios-signal)" strokeWidth="2" fill="none" />
        <path d={toPath("noise")} stroke="var(--bios-noise)" strokeWidth="2" fill="none" strokeDasharray="4 3" />
      </svg>
      <div style={{ display: "flex", gap: 16, marginTop: 8, fontSize: 12, color: "var(--bios-text-muted)" }}>
        <span>
          <span style={{ display: "inline-block", width: 10, height: 2, background: "var(--bios-signal)", marginRight: 6, verticalAlign: "middle" }} />
          Real activity
        </span>
        <span>
          <span style={{ display: "inline-block", width: 10, height: 2, background: "var(--bios-noise)", marginRight: 6, verticalAlign: "middle" }} />
          Narrative
        </span>
      </div>
    </div>
  );
}
